import { combineReducers } from 'redux';
import Users from './Users/reducer';
import SDM17SPG from './SDM17SPG/reducer';
import SDM18HCL from './SDM18HCL/reducer';
import SDM18MVR from './SDM18MVR/reducer';
import Remote from './Remote/reducer';
import Projects from './Projects/reducer';
import Issues from './Issues/reducer';
import SDM20LHT from './SDM20LHT/reducer';
import Security from './Security/reducer';

export default combineReducers({
    Projects,
    Issues,
    Users,
    SDM17SPG,
    SDM18HCL,
    SDM18MVR,
    Remote,
    SDM20LHT,
    Security
});



// WEBPACK FOOTER //
// ./environments/myfhe/data/reducer.js